import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { TextArea, SmallBtn } from "@/components/praticien/fiche/ui";

const uid = () => Math.random().toString(36).slice(2, 9);

export const Sessions = ({ value, onChange, T }) => {
  const sessions = value || [];
  const add = () => onChange([...sessions, { id: uid(), datetime: new Date().toISOString().slice(0, 16), note: "" }]);
  const update = (id, patch) => onChange(sessions.map((s) => (s.id === id ? { ...s, ...patch } : s)));
  const remove = (id) => onChange(sessions.filter((s) => s.id !== id));

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <span className="text-sm text-[var(--ink-soft)]" data-testid="fiche-sessions-count">
          {T.sessionsRealises} : <strong className="text-[var(--ink)]">{sessions.length}</strong>
        </span>
        <SmallBtn onClick={add} testid="fiche-session-add" tone="solid"><Plus size={14} /> {T.addSession}</SmallBtn>
      </div>
      {sessions.length === 0 ? (
        <p className="text-sm text-[var(--ink-soft)] italic">{T.noSessions}</p>
      ) : (
        <div className="space-y-3">
          {sessions.map((s, i) => (
            <div key={s.id} className="rounded-2xl border border-[var(--border)] bg-white/70 p-4" data-testid={`fiche-session-${i}`}>
              <div className="flex items-center gap-3 mb-2">
                <span className="flex items-center justify-center h-7 w-7 rounded-full bg-[var(--gold)] text-white text-sm shrink-0">{i + 1}</span>
                <input
                  type="datetime-local"
                  value={s.datetime || ""}
                  onChange={(e) => update(s.id, { datetime: e.target.value })}
                  data-testid={`fiche-session-date-${i}`}
                  className="rounded-xl border border-[var(--border)] bg-white/80 px-3 py-2 text-sm text-[var(--ink)] focus:outline-none focus:ring-2 focus:ring-[var(--gold-light)]"
                />
                <button onClick={() => remove(s.id)} data-testid={`fiche-session-remove-${i}`} className="ml-auto text-[#B0553B] hover:opacity-70" aria-label={T.removeSession}>
                  <Trash2 size={17} />
                </button>
              </div>
              <TextArea value={s.note} onChange={(v) => update(s.id, { note: v })} testid={`fiche-session-note-${i}`} placeholder={T.sessionNote} rows={2} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
